import React, {ReactElement} from 'react'
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    LinearScale,
    CategoryScale,
    Title,
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import {TransProps} from "@lingui/react";

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    LinearScale,
    CategoryScale,
    Title,
)


export type typeOptions = {
    plugins: {
        title?: {
            display: boolean,
            text: string,
        },
        legend?: {
            position: string,
        },
        tooltip: {
            enabled: boolean,
            position: string,
            backgroundColor: string,
            titleColor: string,
            bodyColor: string,
            borderColor: string,
            borderWidth: number,
            displayColors: boolean,
        }
    },
    responsive: boolean,
}

type typeDataRadial = {
    labels: string[],
    datasets: {
        label: string,
        data: number[],
        backgroundColor?: string[],
        borderWidth?: number,
        fill?: boolean,
        borderColor?: string,
    }[],
}

export type typeData = {
    labels: string[],
    datasets: {
        label: string,
        data: number[],
    }[]
}

const totalOptions: typeOptions = {
    plugins: {
        legend: {
            position: 'bottom' as const,
        },
        tooltip: {
            enabled: true,
            position: 'nearest',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            titleColor: '#333',
            bodyColor: '#333',
            borderColor: 'rgba(0, 0, 0, 0.1)',
            borderWidth: 1,
            displayColors: true,
        },
    },
    responsive: true,
}

const colors = ['#65855e', '#adbca9', '#d6ded4', '#eaefe9', '#f6f8f5']


export type typeRadial = {
    amountTitle?: string | ReactElement<TransProps>,
    data: typeData,
}

export const RadialChart: React.FC<typeRadial> = ({amountTitle, data}) => {

    const totalData: typeDataRadial = {
        labels: data.labels,
        datasets: data.datasets.map((item, index) => {
            return {
                label: item.label,
                data: item.data,
                backgroundColor: item.data.map((item, i) => i < colors.length ? colors[i] : colors[colors.length - 1]),
            }
        })
    }

    return(<>
        {/* @ts-ignore */}
        <Doughnut options={totalOptions} data={totalData} />
    </>)
}